import Swiper from "swiper";
import { Navigation, Autoplay } from "swiper/modules";

export default {
	testimonialSwiper: null,

	init() {
		const el = document.querySelector(".testimonials--swiper");
		if (!el) return;

		this.testimonialSwiper = new Swiper(".testimonials--swiper", {
			modules: [Navigation, Autoplay],

			slidesPerView: 1.15,
			spaceBetween: 15,

			autoplay: {
				delay: 6000,
			},

			speed: 1000,

			navigation: {
				nextEl: ".testimonials .swiper-button-next",
				prevEl: ".testimonials .swiper-button-prev",
			},

			breakpoints: {
				768: {
					slidesPerView: 2,
				},
				1200: {
					slidesPerView: 3,
				},
			},
		});
	},

	destroy() {
		if (this.testimonialSwiper) {
			this.testimonialSwiper.destroy(true, true);
			this.testimonialSwiper = null;
		}
	},
};
